@if (visible) {
  <div class="modal-overlay" (click)="close()">
    <div class="modal-panel" (click)="$event.stopPropagation()">

      <!-- Header -->
      <div class="modal-header">
        <div class="modal-header-content">
          <div class="modal-icon">
            <i class="pi pi-plus-circle"></i>
          </div>
          <div>
            <h3 class="modal-title">Add Subscription</h3>
            <p class="modal-subtitle">Create a new user subscription</p>
          </div>
        </div>
        <button class="close-btn" (click)="close()">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <div class="form-grid">
          <!-- Name -->
          <div class="form-group">
            <label class="form-label">Full Name <span class="required">*</span></label>
            <input
              type="text"
              class="form-control"
              [class.invalid]="errors['name']"
              placeholder="Enter full name"
              [(ngModel)]="form.name" />
              @if (errors['name']) {
                <span class="error-msg">{{ errors['name'] }}</span>
              }
            </div>

            <!-- Email -->
            <div class="form-group">
              <label class="form-label">Email Address <span class="required">*</span></label>
              <input
                type="email"
                class="form-control"
                [class.invalid]="errors['email']"
                placeholder="Enter email address"
                [(ngModel)]="form.email" />
                @if (errors['email']) {
                  <span class="error-msg">{{ errors['email'] }}</span>
                }
              </div>

              <!-- Plan -->
              <div class="form-group">
                <label class="form-label">Subscription Plan <span class="required">*</span></label>
                <select
                  class="form-control"
                  [class.invalid]="errors['plan']"
                  [(ngModel)]="form.plan">
                  <option [ngValue]="null">Select a plan</option>
                  @for (plan of plans; track plan) {
                    <option [value]="plan">{{ plan }}</option>
                  }
                </select>
                @if (errors['plan']) {
                  <span class="error-msg">{{ errors['plan'] }}</span>
                }
              </div>

              <!-- Billing Cycle -->
              <div class="form-group">
                <label class="form-label">Billing Cycle</label>
                <select class="form-control" [(ngModel)]="form.billingCycle">
                  @for (cycle of billingCycles; track cycle) {
                    <option [value]="cycle">{{ cycle }}</option>
                  }
                </select>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer">
            <button class="btn-cancel" (click)="close()">Cancel</button>
            <button class="btn-save" [disabled]="saving()" (click)="submit()">
              @if (!saving()) {
                <i class="pi pi-check"></i>
              }
              @if (saving()) {
                <i class="pi pi-spin pi-spinner"></i>
              }
              {{ saving() ? 'Saving...' : 'Add Subscription' }}
            </button>
          </div>

        </div>
      </div>
    }
